import css from './css/ListComponent.module.css';

import {Col, Container, Row} from "react-bootstrap";
import IconButton from "./IconButton";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import useClaims from "../Hooks/useClaims";

const ListComponent = ({title, onPlusClicked, children, plusButtonClaim, useWrapper = true}) => {

    const { hasClaim } = useClaims()

    const plusButton = <IconButton icon={faPlus} color="white" bg="#198754" onClick={onPlusClicked}/>

    return (
        <Container>
            <Row>
                <Col className='ps-0'>
                    <h1 className="mb-0">{title}</h1>
                </Col>
                <Col className="d-flex align-items-center justify-content-end pe-0" sm={1}>
                    {plusButtonClaim ? hasClaim(plusButtonClaim) && plusButton : plusButton}
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col className={useWrapper ? css.wrapper : ''}>
                    {children}
                </Col>
            </Row>
        </Container>
    );
};

export default ListComponent;